import { loadAllDeletedTrees } from "./searchFunctions";

export async function showDeletedTrees() {
  const alleGefaelltenBaeume = await loadAllDeletedTrees();
  let headersSet = false;
  let tableString = `<table id='gefaellteBaeumeDataTable' class='table table-striped display compact hover '>`;

  alleGefaelltenBaeume.forEach(function (feature) {
    const entries = Object.entries(feature.properties);

    if (!headersSet) {
      const headers = entries.map(([key]) => `<th>${key}</th>`).join("");
      tableString += `<thead><tr>${headers}</tr></thead>`;
      headersSet = true;
    }

    const cells = entries.map(([, val]) => `<td>${val}</td>`).join("");
    tableString += `<tr>${cells}</tr>`;
  });

  tableString += `</table>`;
  document.getElementById("gefaellteBaeumeTableDiv").innerHTML = tableString;
}
